import { useState } from 'react';
import Button from '../../../../components/Button/Button';
import FormHeading from '../../../../components/Typography/FormHeading';
import {
  DEAL_STATUS_CAR_DELIVERY,
  DEAL_STATUS_WAIRING_REGISTRATION,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_MARRIAGE_CONTRACT,
  DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
  DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
  DOCUMENT_TYPES_PAYMENT_ORDER,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
} from '../../../../constants';
import CarDelivery from '../CommonBankSteps/CarDelivery';
import LoaderInline from '../../../../components/Loader/LoaderInline';
import ContractSign from '../CommonBankSteps/ContractSign';
import CarRegistration from '../CommonBankSteps/CarRegistration';
import carRegistration from '../../../../api/cars/registration';
import CheckBankStatus from '../CommonBankSteps/CheckBankStatus';
import setStep from '../../../../api/deals/setStep';
import PaymentStatus from '../CommonBankSteps/PaymentStatus';
import NotarialDocuments from './NotarialDocuments';
import editDeal from '../../../../api/deals/editDeal';
import generateAllowedDocumentsJson from '../../../../utils/generateAllowedDocumentsJson';
import extractErrorMessage from '../../../../utils/extractErrorMessage';
import EditCarGosNumber from '../CommonBankSteps/EditCarGosNumber';
import editCar from '../../../../api/cars/editCar';
import alert from '../../../../helpers/alert';
import StepControlButtons from '../CommonBankSteps/StepControlButtons';
import processDocument from '../../../../api/bank/processDocument';
import UploadAdditionalDocuments from './UploadAdditionalDocuments';
import uploadDocumentToDeal from '../../../../api/deals/uploadDocumentToDeal';
import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import vehicleValuation from '../../../../api/bank/vehicle-valuation';
import DocumentsForUsedCar from './DocumentsForUsedCar';
const EurazFlow = ({ step, deal, goBack, update, documents, cars, bankId, chosenBankAppealId, chosenBankAppeal }) => {
  const [loading, setLoading] = useState(false);

  //ÐÐ¾Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð´Ð»Ñ Ð¾Ð½Ð»Ð°Ð¹Ð½ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð°.
  //ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ ÑÐ°Ð³, ÐµÑÐ»Ð¸ ÑÐ¾ÑÐµÑ Ð¾ÑÑÐ»Ð°Ð¹Ð½ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ
  let initialRegistration = true;
  let preferentialLoan = false;
  try {
    // initialRegistration = JSON.parse(deal?.creditAppeal?.json)?.initialRegistration || false;
    preferentialLoan = JSON.parse(deal?.creditAppeal?.json)?.benefit || false;
  } catch (e) {}
  const onRegistrationSubmit = async (values) => {
    try {
      setLoading(true);
      await carRegistration({
        bankId,
        chunkId: deal?.chunkId,
        carId: cars?.[0]?.id,
        reg_num: '',
      });
      await setStep({ dealId: deal?.id, step: DEAL_STEPS.EURAZ.CAR_DELIVERY });
      update && update();
    } catch (e) {
      alert.error(e);
      setLoading(false);
    }
  };
  const skipPaymentStep = async () => {
    const nextStep = cars?.[0]?.used
      ? DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR
      : initialRegistration
        ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
        : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
    await setStep({ dealId: deal?.id, step: nextStep });
    update && update();
  };

  const onPaymentSubmit = async (values) => {
    setLoading(true);

    editDeal({
      id: deal?.id,
      statusPaymentId: values?.status?.value,
      statusId: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
        DOCUMENT_TYPES_INVOICE,
        DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
        DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        DOCUMENT_TYPES_SPOUSE_CONSENT,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
        DOCUMENT_TYPES_PAYMENT_ORDER,
        DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
      ]),
    })
      .then(async () => {
        const nextStep = cars?.[0]?.used
          ? DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR
          : initialRegistration
            ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
            : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
        await setStep({ dealId: deal?.id, step: nextStep });

        alert.success('Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½');
        update && update();
      })
      .catch((err) => {
        alert.error(extractErrorMessage(err?.response?.data) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const editCarGosNumber = async (values) => {
    try {
      setLoading(true);

      await editCar(cars?.[0]?.id, {
        grnz: values['grnz'],
        texNumber: values['texNumber'],
      });

      await editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_WAIRING_REGISTRATION,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
          DOCUMENT_TYPES_PAYMENT_ORDER,
          DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
          DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
        ]),
      });
      await setStep({ dealId: deal?.id, step: DEAL_STEPS.EURAZ.AUTO_REGISTRATION });
      update && update();
    } catch (e) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
    } finally {
      setLoading(false);
    }
  };

  const onUploadAdditionalDocumentsSuccess = async () => {
    await setStep({ dealId: deal?.id, step: DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION });
    update && update();
  };

  const onDocumentsForUsedCarSuccess = async () => {
    const nextStep = initialRegistration
      ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
      : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
    await setStep({ dealId: deal?.id, step: nextStep });
    update && update();
  };

  const onNotarialDocumentsSuccess = async (values) => {
    const nextStep = initialRegistration ? DEAL_STEPS.EURAZ.CAR_DELIVERY : DEAL_STEPS.EURAZ.AUTO_REGISTRATION;
    editDeal({
      id: deal?.id,
      dealId: deal?.id,
      statusId: DEAL_STATUS_WAIRING_REGISTRATION,
      step: nextStep,
      power_of_attorney_number: values?.powerOfAttorneyNumber
        ? values?.powerOfAttorneyNumber
        : deal?.power_of_attorney_number,
      ...generateAllowedDocumentsJson([
        DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
        DOCUMENT_TYPES_INVOICE,
        DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
        DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        DOCUMENT_TYPES_SPOUSE_CONSENT,
        DOCUMENT_TYPES_GUARANTEE_LETTER,
        DOCUMENT_TYPES_PAYMENT_ORDER,
        DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
        DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
      ]),
    })
      .then(async () => {
        // const hasRequiredDocuments = documents?.some((doc) =>
        //   [
        //     DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        //     DOCUMENT_TYPES_SPOUSE_CONSENT,
        //     DOCUMENT_TYPES_MARRIAGE_CONTRACT,
        //     DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
        //     DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
        //   ].includes(doc.typeId)
        // );

        const hasDocumentError = [
          'EXTRAJUDICIAL_ENFORCEMENT',
          'MARRIAGE_CONTRACT',
          'NOTARIZED_SPOUSE_CONSENT',
          'PLEDGE_REGISTRATION_CERTIFICATE',
          'PLEDGE_AGREEMENT',
        ].some((code) => chosenBankAppeal?.errorMessage?.includes(code));

        if (hasDocumentError) {
          await processDocument(deal?.chunkId);
          update();
        } else {
          // sendMarriedDoc Ð²ÑÐ·ÑÐ²Ð°ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ Ð½Ð° ÑÐ°Ð³Ðµ Ð´Ð¾Ð¿. Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² (UploadAdditionalDocuments)
          // Ð±ÑÐ» Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ "ÐÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸" (fileTypeId=42). (Ð¾Ð½Ð»Ð°Ð¹Ð½ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ)
          // ÐÑÐ»Ð¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð±ÑÐ» Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½ â Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼ Ð²ÑÐ·Ð¾Ð² Ð¸ Ð¿ÐµÑÐµÑÐ¾Ð´Ð¸Ð¼ Ðº onSuccess Ð½Ð°Ð¿ÑÑÐ¼ÑÑ. (Ð¾ÑÑÐ»Ð°Ð¹Ð½ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ)
          const hasExtendedProducerResponsibilityDoc = documents?.some(
            (doc) => doc?.typeId === DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION
          );
          if (hasExtendedProducerResponsibilityDoc) {
            sendMarriedDoc({ appealId: chosenBankAppealId })
              .then(() => {
                update();
              })
              .catch(() => {
                alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
                setLoading(false);
              });
          } else {
            update();
          }
        }
      })
      .catch((err) => {
        alert.error(extractErrorMessage(err?.response?.data) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const stepAfterContractSign = DEAL_STEPS.EURAZ.WAITING_FOR_PAYMENT;

  if (loading) {
    return <LoaderInline />;
  }

  if (step === DEAL_STEPS.EURAZ.SIGN_CONTRACT) {
    return (
      <ContractSign
        deal={deal}
        documents={documents}
        cars={cars}
        dealStepAfterSign={stepAfterContractSign}
        setLoading={setLoading}
        update={update}
      />
    );
  }
  if (step === DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR) {
    const nextStep = initialRegistration
      ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
      : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.EURAZ.WAITING_FOR_PAYMENT}
          nextStep={nextStep}
          update={update}
          setLoading={setLoading}
        />
        <DocumentsForUsedCar
          documents={documents}
          loading={loading}
          onSuccess={onDocumentsForUsedCarSuccess}
          deal={deal}
          setLoading={setLoading}
          chosenBankAppealId={chosenBankAppealId}
          bankId={bankId}
          chosenBankAppeal={chosenBankAppeal}
        />
      </>
    );
  }
  if (step === DEAL_STEPS.EURAZ.WAITING_FOR_PAYMENT) {
    const nextStep = cars?.[0]?.used
      ? DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR
      : initialRegistration
        ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
        : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
    const prevStep = DEAL_STEPS.EURAZ.SIGN_CONTRACT;
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          nextStep={nextStep}
          prevStep={prevStep}
          update={update}
          setLoading={setLoading}
        />
        <PaymentStatus
          onSubmit={onPaymentSubmit}
          documents={documents}
          deal={deal}
          chunkId={deal?.chunkId}
          setLoading={setLoading}
          loading={loading}
          bankId={bankId}
        />
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between' }}>
          <CheckBankStatus bankId={bankId} chunkId={deal?.chunkId} onSuccess={update} setLoading={setLoading} />
          <Button onClick={skipPaymentStep}>ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ</Button>
        </div>
      </>
    );
  }

  if (step === DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS) {
    const prevStep = cars?.[0]?.used
      ? DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR
      : DEAL_STEPS.EURAZ.WAITING_FOR_PAYMENT;
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={prevStep}
          nextStep={DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION}
          update={update}
          setLoading={setLoading}
        />
        <UploadAdditionalDocuments
          documents={documents}
          loading={loading}
          onSuccess={onUploadAdditionalDocumentsSuccess}
          deal={deal}
          setLoading={setLoading}
          chosenBankAppealId={chosenBankAppealId}
          bankId={bankId}
        />
        <div style={{ marginTop: 20 }}>
          <CheckBankStatus bankId={bankId} chunkId={deal?.chunkId} onSuccess={update} setLoading={setLoading} />
        </div>
      </>
    );
  }
  if (step === DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION) {
    const nextStep = initialRegistration ? DEAL_STEPS.EURAZ.CAR_DELIVERY : DEAL_STEPS.EURAZ.AUTO_REGISTRATION;
    const prevStep = initialRegistration
      ? DEAL_STEPS.EURAZ.ADIITIONAL_DOCUMENTS
      : cars?.[0]?.used
        ? DEAL_STEPS.EURAZ.DOCUMENTS_FOR_USED_CAR
        : DEAL_STEPS.EURAZ.WAITING_FOR_PAYMENT;
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={prevStep}
          nextStep={nextStep}
          update={update}
          setLoading={setLoading}
        />
        <NotarialDocuments
          documents={documents}
          loading={loading}
          onSuccess={onNotarialDocumentsSuccess}
          deal={deal}
          setLoading={setLoading}
          chosenBankAppealId={chosenBankAppealId}
          bankId={bankId}
          preferentialLoan={preferentialLoan}
        />
        <div style={{ marginTop: 20 }}>
          <CheckBankStatus bankId={bankId} chunkId={deal?.chunkId} onSuccess={update} setLoading={setLoading} />
        </div>
      </>
    );
  }

  if (step === DEAL_STEPS.EURAZ.EDIT_CAR_GOS_NUMBER) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION}
          nextStep={DEAL_STEPS.EURAZ.AUTO_REGISTRATION}
          update={update}
          setLoading={setLoading}
        />
        <EditCarGosNumber onSubmit={editCarGosNumber} loading={loading} />
      </>
    );
  }

  if (step === DEAL_STEPS.EURAZ.AUTO_REGISTRATION) {
    // const prevStep = preferentialLoan ? DEAL_STEPS.EURAZ.EDIT_CAR_GOS_NUMBER : DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION;
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.EURAZ.NOTARIAL_VERIFICATION}
          nextStep={DEAL_STEPS.EURAZ.CAR_DELIVERY}
          update={update}
          setLoading={setLoading}
        />
        <CarRegistration
          onSuccess={onRegistrationSubmit}
          deal={deal}
          setLoading={setLoading}
          loading={loading}
          statusOption={[
            {
              value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
              label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¢Ð¡ Ð½Ð° ÑÑÐµÑ',
            },
            {
              value: DEAL_STATUS_CAR_DELIVERY,
              label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð½Ð° ÑÑÐµÑ',
            },
          ]}
          creditAppeal={chosenBankAppeal}
        />
        <div style={{ marginTop: 20 }}>
          <CheckBankStatus bankId={bankId} chunkId={deal?.chunkId} onSuccess={update} setLoading={setLoading} />
        </div>
      </>
    );
  }

  if (step === DEAL_STEPS.EURAZ.CAR_DELIVERY) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.EURAZ.AUTO_REGISTRATION}
          nextStep={DEAL_STEPS.FINISH}
          update={update}
          setLoading={setLoading}
        />
        <CarDelivery deal={deal} loading={loading} setLoading={setLoading} onSuccess={update} />;
      </>
    );
  }
};

export default EurazFlow;
